import numeral from 'numeral';

export const formatRollupCell = value => {
  const num = numeral(value);

  if (value <= 9999) {
    return num.format('0,0');
  }

  return num.format('0a');
};
